import React, { useMemo } from 'react';
import { useIntl } from 'react-intl';
import clsx from 'clsx';
import { TypedMemo } from '../../../common/types';
import { mailboxMessages as messages } from './mailboxMessages';
/* eslint-disable css-modules/no-unused-class -- one stylesheet for the whole Mailboxes card; each part uses its own slice of it */
import styles from './Mailboxes.module.scss';

/** More slots than this show the count only, with no pips. */
const MAX_PIPS = 10;

interface MailboxListHeadProps {
  used: number;
  limit: number;
}

/** The head of the Mailboxes card (design outreach-v2 q1): title, one line and the slot pips. */
const MailboxListHeadComponent: React.FC<MailboxListHeadProps> = ({ used, limit }) => {
  const intl = useIntl();
  const pips = useMemo(
    () =>
      limit > 0 && limit <= MAX_PIPS
        ? Array.from({ length: limit }, (_, index) => (
            // eslint-disable-next-line react/no-array-index-key -- one pip per slot
            <i key={index} className={clsx(index < used && styles.pipOn)} />
          ))
        : null,
    [limit, used]
  );
  return (
    <div className={styles.head}>
      <div className="flex-grow-1">
        <h3 className={styles.headTitle}>{intl.formatMessage(messages.yourMailboxes)}</h3>
        <p className={styles.headSub}>{intl.formatMessage(messages.subtitle)}</p>
      </div>
      <div className={styles.slots} data-testid="mailbox-slots">
        {pips !== null && (
          <span className={styles.pips} aria-hidden="true">
            {pips}
          </span>
        )}
        <span>{intl.formatMessage(messages.usage, { count: used, limit })}</span>
      </div>
    </div>
  );
};

export const MailboxListHead = TypedMemo(MailboxListHeadComponent);
